<template>
   <v-card
          class="pa-2"
          outlined
          tile
        >
         <p class='grey--text title'>Past Surgical History:</p>
         
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Name of surgery</th>
          <th class="text-left">surgery date</th>
          <th class="text-left">Details</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in currentPatient.health.surgeries" :key="item.name">
          <td>{{ item.name }}</td>
          <td>{{ item.date }}</td>
          <td>{{ item.detail }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
        </v-card>
</template>

<script>
export default {
    props : {
        currentPatient : Object
    }
}
</script>

<style>

</style>